"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishedDatasourceIconTooltip = exports.PublishedDatasourceIcon = void 0;
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var icons_1 = require("../../../gen-src/icons");
function PublishedDatasourceIcon(publishedDatasource) {
    if (publishedDatasource.hasExtracts) {
        if (publishedDatasource.isCertified) {
            return react_1.default.createElement(icons_1.SvgSpacesMediumExtractCertified, null);
        }
        else {
            return react_1.default.createElement(icons_1.SvgSpacesMediumExtract, null);
        }
    }
    else {
        if (publishedDatasource.isCertified) {
            return react_1.default.createElement(icons_1.SvgSpacesMediumDsCertified, null);
        }
        else {
            return react_1.default.createElement(icons_1.SvgSpacesMediumDs, null);
        }
    }
}
exports.PublishedDatasourceIcon = PublishedDatasourceIcon;
function PublishedDatasourceIconTooltip(publishedDatasource) {
    if (publishedDatasource.hasExtracts) {
        if (publishedDatasource.isCertified) {
            return Localize_1.Messages.DataDetailsCertifiedDatasourceExtract();
        }
        else {
            return Localize_1.Messages.DataDetailsDatasourceExtract();
        }
    }
    else {
        if (publishedDatasource.isCertified) {
            return Localize_1.Messages.DataDetailsCertifiedDatasourceLive();
        }
        else {
            return Localize_1.Messages.DataDetailsDatasourceLive();
        }
    }
}
exports.PublishedDatasourceIconTooltip = PublishedDatasourceIconTooltip;
//# sourceMappingURL=PublishedDatasourceIcon.js.map